import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phoneFilled"
const PhoneFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.43 2.585C6.983 2.03 7.923 2.2 8.25 2.915L10.237 7.29C10.43 7.717 10.339 8.22 10.008 8.55L8.325 10.233C8.577 11.348 9.146 12.42 10.03 13.303 10.913 14.186 11.985 14.753 13.1 15.006L14.781 13.324C15.112 12.994 15.615 12.901 16.042 13.095L20.418 15.084C21.088 15.388 21.279 16.234 20.844 16.795L20.748 16.904 17.536 20.116C17.352 20.3 17.097 20.364 16.863 20.319 13.644 20.91 9.657 19.66 6.664 16.669 3.671 13.675 2.422 9.688 3.013 6.469 2.968 6.234 3.033 5.98 3.217 5.796z" />
        </svg>
      }
    </span>
  )
}
export default PhoneFilledIcon
